module.exports = __webpack_public_path__ + "static/media/bitmovin_logo.67f4cec5.svg";